import { jsx as _jsx } from "react/jsx-runtime";
import { useAuth } from 'react-oidc-context';
import { useOfficeTheme } from '../lib/useOfficeTheme';
import { useOidcMessageHandler } from '../hooks/useOidcMessageHandler';
import AuthNavigator from './auth/AuthNavigator';
import { McpSessionProvider } from './McpSessionProvider';
import Main from './pages/Main';
export default function App() {
    const { isAuthenticated } = useAuth();
    const theme = useOfficeTheme();
    // Handle OIDC messages from auth popup
    useOidcMessageHandler();
    return (_jsx("div", { className: `h-full ${theme.isDark ? 'dark' : ''}`, children: _jsx("div", { className: "h-full bg-background text-foreground", children: isAuthenticated ? (_jsx(McpSessionProvider, { children: _jsx(Main, {}) })) : (_jsx(AuthNavigator, {})) }) }));
}
